const config = {
  host: 'https://qa.api.platform-ils.mmg.zone',
};

export default config;
